import React from 'react';
export function EditorTextItalicIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M8 3h12v2h-5.22l-3.5 14H16v2H4v-2h5.22l3.5-14H8V3z"
  }));
}